define(
({
  "alert": "Uyarı",
  "okay": "Tamam"
})
);
